import { render, staticRenderFns } from "./AreaIcon.vue?vue&type=template&id=e8494c66&"
import script from "./AreaIcon.vue?vue&type=script&lang=js&"
export * from "./AreaIcon.vue?vue&type=script&lang=js&"
import style0 from "./AreaIcon.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports